// نسخة المؤسسة على جهاز مديرها - نظام مستقل تماما عن النسخ السحابي
import JSZip from "jszip";

const FILE_LABELS = {
  coverAr: "الغلاف_العربي", coverFr: "الغلاف_الأصلي",
  contractAuthor: "عقد_المؤلف", contractTrans1: "عقد_الترجمة",
  contractPublisher: "عقد_الناشر", printOfferFile: "عرض_الطباعة",
};
const safeName = (x) => String(x || "بدون اسم").replace(/[\/\\:*?"<>|\n\r\t]+/g, "_").slice(0, 80);
const extFromDataUrl = (u) => {
  const m = /^data:([^;]+)/.exec(u || ""); const mime = m ? m[1] : "";
  const map = { "image/jpeg": "jpg", "image/jpg": "jpg", "image/png": "png", "image/webp": "webp", "image/gif": "gif", "application/pdf": "pdf", "application/msword": "doc", "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx", "application/vnd.ms-excel": "xls", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx", "text/plain": "txt" };
  return map[mime] || "bin";
};
const putDataUrl = (zip, path, dataUrl) => {
  try {
    const i = dataUrl.indexOf("base64,");
    if (i === -1) return false;
    zip.file(path, dataUrl.slice(i + 7), { base64: true });
    return true;
  } catch { return false; }
};
const fileData = (v) => {
  if (typeof v === "string" && v.startsWith("data:")) return v;
  if (v && typeof v === "object" && typeof v.data === "string" && v.data.startsWith("data:")) return v.data;
  return null;
};
const cleanBook = (bk) => {
  const c = { ...bk };
  for (const k of Object.keys(FILE_LABELS)) delete c[k];
  delete c.filesTrash;
  return c;
};

export async function orgDesktopBackup(d, flash) {
  const zip = new JSZip();
  const stamp = new Date(Date.now() + 3 * 3600 * 1000).toISOString().slice(0, 10);
  const root = "نسخة احتياطية " + stamp;
  const idx = { created: new Date().toISOString(), sections: {} };
  let filesCount = 0;

  // ═══ القسم 1: الجهات - الشجرة الحقيقية ═══
  flash && flash("انتظر دقائق لتجمع ملفاتك من النظام السحابي...");
  const { supabase: sb0 } = await import("./supabaseClient.js");
  const putBookPath = async (zipPath, storagePath, fallbackName) => {
    try {
      const { data: blob } = await sb0.storage.from("book-files").download(storagePath);
      if (blob) { zip.file(zipPath, blob); return true; }
    } catch { /* متعذر */ }
    return false;
  };
  const pubs = (d && d.publishers) || [];
  let nPubs = 0, nProjs = 0, nBooks = 0;
  for (const pub of pubs) {
    if (!pub || pub.deleted) continue;
    nPubs++;
    const pubDir = root + "/الجهات/" + safeName(pub.name);
    for (const proj of pub.projects || []) {
      if (!proj || proj.deleted) continue;
      nProjs++;
      const projDir = pubDir + "/" + safeName(proj.name);
      for (const bk of proj.works || []) {
        if (!bk || bk.deleted) continue;
        nBooks++;
        const bkDir = projDir + "/" + safeName(bk.name);
        for (const [key, label] of Object.entries(FILE_LABELS)) {
          const v = bk[key];
          const u = fileData(v);
          if (u) {
            if (putDataUrl(zip, bkDir + "/" + label + "." + extFromDataUrl(u), u)) filesCount++;
          } else if (v && typeof v === "object" && v.path) {
            const ex = ((v.name || "").split(".").pop() || "bin").slice(0, 6);
            if (await putBookPath(bkDir + "/" + label + "." + ex, v.path)) filesCount++;
          }
        }
        if (Array.isArray(bk.filesTrash) && bk.filesTrash.length) {
          let ti = 0;
          for (const item of bk.filesTrash) {
            const vf = item && item.file;
            if (vf && typeof vf === "object" && vf.path && !fileData(vf)) {
              ti++;
              const ex2 = ((vf.name || "").split(".").pop() || "bin").slice(0, 6);
              if (await putBookPath(bkDir + "/المحذوفات/" + safeName(item.label || vf.name || ("ملف_" + ti)) + "." + ex2, vf.path)) filesCount++;
              continue;
            }
            const u = item && (fileData(item.file) || fileData(item));
            if (u) {
              ti++;
              const nm = safeName(item.label || item.name || ("ملف_" + ti));
              if (putDataUrl(zip, bkDir + "/المحذوفات/" + nm + "." + extFromDataUrl(u), u)) filesCount++;
            }
          }
        }
        if (nBooks === 1) {
          const sample = {};
          for (const k of Object.keys(FILE_LABELS)) {
            const v = bk[k];
            sample[k] = v == null ? "فارغ" : (typeof v === "string" ? ("سلسلة: " + v.slice(0, 50)) : ("كائن: " + Object.keys(v).join(",") + (v.data ? " | data يبدأ: " + String(v.data).slice(0, 30) : "")));
          }
          idx.sections["تشخيص-الكتاب-الأول"] = { "كل_حقول_الكتاب": Object.keys(bk).join(" | "), "الخانات_الست": sample };
        }
        for (const cf of bk.customFiles || []) {
          const vf = cf && cf.file;
          if (!vf) continue;
          const cu = fileData(vf);
          const cext = ((vf.name || "").split(".").pop() || "bin").slice(0, 6);
          if (cu) { if (putDataUrl(zip, bkDir + "/" + safeName(cf.label) + "." + extFromDataUrl(cu), cu)) filesCount++; }
          else if (vf.path) { if (await putBookPath(bkDir + "/" + safeName(cf.label) + "." + cext, vf.path)) filesCount++; }
        }
        zip.file(bkDir + "/بيانات-الكتاب.json", JSON.stringify(cleanBook(bk), null, 2));
      }
    }
  }
  idx.sections["الجهات"] = { "جهات": nPubs, "مشاريع": nProjs, "كتب": nBooks, "ملفات حقيقية": filesCount };

  // ═══ القسم 2: المشاريع الجماعية - بجلسة المدير (عزل RLS بنيوي) ═══
  flash && flash("جار جمع المشاريع الجماعية وملفاتها...");
  try {
    const { supabase } = await import("./supabaseClient.js");
    const grab = async (t) => { try { const { data } = await supabase.from(t).select("*").limit(5000); return data || []; } catch { return []; } };
    const [teams, tprojects, tasks, tcomments, tfiles, tmembers, relBooks] = await Promise.all([
      grab("teams"), grab("team_projects"), grab("tasks"), grab("task_comments"), grab("task_files"), grab("team_members"), grab("rel_books"),
    ]);
    const bookName = (id) => { const b = relBooks.find((x) => x.id === id); return b ? b.name : null; };
    const taskProj = {};
    for (const t of tasks) { taskProj[t.id] = t.project_id || t.team_project_id || null; }
    const projDirs = {};
    let nFiles = 0, nProj = 0;
    for (const tp of tprojects) {
      nProj++;
      const pDir = root + "/المشاريع-الجماعية/" + safeName(tp.name || tp.title || ("مشروع_" + tp.id));
      projDirs[tp.id] = pDir;
      const pTasks = tasks.filter((t) => t.project_id === tp.id || t.team_project_id === tp.id || (tp.team_id && t.team_id === tp.team_id));
      const tIds = new Set(pTasks.map((t) => t.id));
      const pComments = tcomments.filter((cm) => tIds.has(cm.task_id));
      const linkedBooks = [tp.book_id, tp.rel_book_id].filter(Boolean).map(bookName).filter(Boolean);
      zip.file(pDir + "/بيانات-المشروع.json", JSON.stringify({ ...tp, "الكتب_المرتبطة": linkedBooks }, null, 2));
      if (pTasks.length) zip.file(pDir + "/المهام.json", JSON.stringify(pTasks, null, 2));
      if (pComments.length) zip.file(pDir + "/التعليقات.json", JSON.stringify(pComments, null, 2));
    }
    // الشمول القاطع: كل ملف ينزل - لمشروعه إن عرف وإلا للعام
    for (const f of tfiles) {
      const path = f.file_path || f.path || f.storage_path;
      if (!path || typeof path !== "string") continue;
      const owner = projDirs[f.project_id] || projDirs[taskProj[f.task_id]] || (root + "/المشاريع-الجماعية/ملفات-عامة");
      try {
        const { data: blob } = await supabase.storage.from("team-files").download(path);
        if (blob) {
          const nm = safeName(f.file_name || path.split("/").pop());
          const ver = f.version_label ? (safeName(f.version_label) + "_") : "";
          zip.file(owner + "/الملفات/" + ver + nm, blob);
          nFiles++;
        }
      } catch { /* فشل تنزيل فردي - يسجل بالفهرس عبر الفارق */ }
    }
    if (teams.length) zip.file(root + "/المشاريع-الجماعية/الفرق.json", JSON.stringify(teams, null, 2));
    if (tmembers.length) zip.file(root + "/المشاريع-الجماعية/الأعضاء.json", JSON.stringify(tmembers, null, 2));
    idx.sections["المشاريع الجماعية"] = { "مشاريع": nProj, "مهام": tasks.length, "ملفات في الجدول": tfiles.length, "ملفات حقيقية نزلت": nFiles };
  } catch (e) {
    idx.sections["المشاريع الجماعية"] = { "تعذر": String(e && e.message || e) };
  }

  // (القضمات القادمة تضاف هنا: المشاريع الجماعية، المترجمون، النظام)

  zip.file(root + "/فهرس-النسخة.json", JSON.stringify(idx, null, 2));
  flash && flash("جار ضغط النسخة...");
  const blob = await zip.generateAsync({ type: "blob", compression: "DEFLATE", compressionOptions: { level: 6 } });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = root + ".zip";
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 30000);
  return { pubs: nPubs, projs: nProjs, books: nBooks, files: filesCount, size: blob.size };
}


// ═══ ملفات الكتب: رفع دائم للمخزن + روابط موقعة ═══
let _orgCache = null;
async function _getOrg(supabase) {
  if (_orgCache) return _orgCache;
  const { data: u } = await supabase.auth.getUser();
  const { data: prof } = await supabase.from("profiles").select("org_id").eq("id", u.user.id).single();
  _orgCache = prof && prof.org_id;
  return _orgCache;
}
export async function uploadBookFile(f) {
  const { supabase } = await import("./supabaseClient.js");
  const org = await _getOrg(supabase);
  if (!org) throw new Error("تعذر تحديد المؤسسة");
  const i = (f.data || "").indexOf("base64,");
  if (i === -1) throw new Error("صيغة ملف غير مقروءة");
  const bin = atob(f.data.slice(i + 7));
  const bytes = new Uint8Array(bin.length);
  for (let j = 0; j < bin.length; j++) bytes[j] = bin.charCodeAt(j);
  const ext = ((f.name || "").split(".").pop() || "bin").toLowerCase().slice(0, 6);
  const path = org + "/books/" + Date.now() + "_" + Math.random().toString(36).slice(2, 8) + "." + ext;
  const { error } = await supabase.storage.from("book-files").upload(path, bytes, { contentType: f.type || "application/octet-stream" });
  if (error) throw error;
  return { name: f.name, type: f.type, path };
}
export async function bookFileUrls(paths) {
  const list = [...new Set((paths || []).filter(Boolean))];
  if (!list.length) return {};
  const { supabase } = await import("./supabaseClient.js");
  const { data } = await supabase.storage.from("book-files").createSignedUrls(list, 3600);
  const out = {};
  (data || []).forEach((d) => { if (d && d.path && d.signedUrl) out[d.path] = d.signedUrl; });
  return out;
}
export async function bookFileUrl(path) {
  const { supabase } = await import("./supabaseClient.js");
  const { data } = await supabase.storage.from("book-files").createSignedUrl(path, 3600);
  return (data && data.signedUrl) || null;
}


export async function saveStoredFile(file, customName) {
  const { supabase } = await import("./supabaseClient.js");
  const { data: blob, error } = await supabase.storage.from("book-files").download(file.path);
  if (error || !blob) { alert("تعذر التنزيل: " + ((error && error.message) || "")); return false; }
  const name = customName || file.name || "ملف";
  if (window.showSaveFilePicker) {
    try {
      const h = await window.showSaveFilePicker({ suggestedName: name });
      const w = await h.createWritable(); await w.write(blob); await w.close();
      return true;
    } catch (e) { if (e && e.name === "AbortError") return false; }
  }
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url; link.download = name;
  document.body.appendChild(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30000);
  return true;
}
export async function downloadStoredFile(file) { return saveStoredFile(file); }
